import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Prepends each key of an object with 'data-'
 */
var computeDataAttributes = function computeDataAttributes(dataAttributes) {
  if (!dataAttributes) {
    return {};
  }

  return Object.keys(dataAttributes).reduce(function (updatedEntries, key) {
    var value = dataAttributes[key];
    return _objectSpread(_objectSpread({}, updatedEntries), {}, _defineProperty({}, "data-".concat(key), value));
  }, {});
};

export default computeDataAttributes;